import { ICarePlanInterventionsStore } from './types';

const initStore: ICarePlanInterventionsStore = {
  items: [],
};

export default initStore;
